sequenceIndex